// src/js/components/RechargeWidget.js
var RechargeWidget = class {
  constructor(el, sel) {
    this.el = el;
    this.widgetType = el.getAttribute(sel);
    this.input = el.querySelector("input");
    this.value = this.input.value;
    this.inputs = [this.input, document.querySelector("#sticky-cta-selling-plan")];
    this.updateAnchor = el.closest("[data-widget-container]").querySelector("[data-ajaxcart-rc-widget-confirm]");
    this.currentValue = this.input.value;
    this.select = el.querySelector("[data-recharge-select]");
    this.selectLabel = el.querySelector("[data-recharge-select-label]");
    this.optionContainer = el.querySelector("[data-recharge-option-container]");
    this.sellingPlanOptions = el.querySelectorAll("[data-recharge-option]");
    this.listItemParent = el.closest("li");
    if (this.listItemParent) {
      this.oneTimePrice = this.listItemParent.querySelector(
        "[data-onetime-price]"
      );
      this.subscriptionPrice = this.listItemParent.querySelector(
        "[data-discount-price]"
      );
    }
    if (this.widgetType !== "in cart")
      this.initPdpWidget();
  }
  init() {
    this.initRecharge();
    if (this.widgetType !== "in cart") {
    } else {
      this.initCartWidget();
    }
  }
  initRecharge() {
    this.select.addEventListener("click", () => {
      this.optionContainer.classList.add("active");
    });
    if (this.sellingPlanOptions) {
      this.sellingPlanOptions.forEach((option) => {
        option.addEventListener("click", (e) => {
          e.preventDefault();
          const value = option.getAttribute("data-value");
          this.inputs.forEach((input) => {
            if (input)
              input.value = value;
          });
          this.value = value;
          this.currentValue = value;
          this.select.setAttribute("data-current-value", value);
          if (this.widgetType === "in cart") {
            this.updateHref(this.currentValue);
          } else {
            this.updateLocation(this.currentValue);
          }
          this.selectLabel.innerHTML = option.innerHTML;
          this.optionContainer.classList.remove("active");
          if (this.oneTimePrice && this.subscriptionPrice) {
            if (this.value) {
              this.oneTimePrice.classList.add("hidden");
              this.subscriptionPrice.classList.remove("hidden");
            } else {
              this.oneTimePrice.classList.remove("hidden");
              this.subscriptionPrice.classList.add("hidden");
            }
          }
        });
      });
    }
    document.body.addEventListener("click", (e) => {
      if (e.target !== this.optionContainer && e.target !== this.select && !e.target.closest("[data-recharge-option-container]") && !e.target.closest("[data-recharge-select]")) {
        this.optionContainer.classList.remove("active");
      }
    });
  }
  updateHref(value) {
    const href = this.updateAnchor.getAttribute("href").split("&selling_plan=")[0];
    this.updateAnchor.setAttribute("href", `${href}&selling_plan=${value}`);
  }
  updateLocation(value) {
    window.history.pushState({ path: value }, "", `${location.pathname}?selling_plan=${value}`);
  }
  clearLocation() {
    const url = new URL(window.location.href);
    url.search = "";
    window.history.replaceState({}, "", url);
  }
  initPdpWidget() {
    const radios = this.el.closest("form[data-product-form]").querySelectorAll('input[type="radio"][name^="purchaseType"]');
    const modalToggle = this.el.closest("[data-product-form]").querySelector("[data-upsell-modal-toggle]");
    const mainSubmit = this.el.closest("[data-product-form]").querySelector("[data-upsell-modal-main-submit]");
    if (radios.length > 0) {
      document.querySelectorAll("[data-price-update-el]").forEach((el) => {
        radios.forEach((radio) => {
          if (!radio.checked) {
            el.innerHTML = radio.getAttribute("data-price");
          }
        });
      });
      radios.forEach((radio) => {
        radio.addEventListener("change", (e) => {
          if (!e.target.checked) {
            return;
          }
          if (e.target.value == "subscription") {
            if (!this.currentValue)
              this.currentValue = this.select.getAttribute("data-current-value");
            this.inputs.forEach((input) => {
              if (input)
                input.value = this.currentValue;
            });
            this.value = this.currentValue;
            this.updateLocation(this.currentValue);
            if (modalToggle && mainSubmit) {
              modalToggle.style.display = "none";
              mainSubmit.style.display = "block";
            }
          } else if (e.target.value == "one-time") {
            this.inputs.forEach((input) => {
              if (input)
                input.value = "";
            });
            this.value = "";
            this.clearLocation();
            if (modalToggle && mainSubmit) {
              modalToggle.style.display = "block";
              mainSubmit.style.display = "none";
            }
          }
          document.querySelectorAll("[data-price-update-el]").forEach((el) => {
            radios.forEach((radio2) => {
              if (!radio2.checked) {
                el.innerHTML = radio2.getAttribute("data-price");
              }
            });
          });
        });
      });
    }
  }
  initCartWidget() {
    const radios = this.el.closest("[data-widget-container]").querySelectorAll('input[type="radio"][name^="purchaseType"]');
    if (radios.length > 0) {
      radios.forEach((radio) => {
        radio.addEventListener("change", (e) => {
          if (!e.target.checked) {
            return;
          }
          const href = this.updateAnchor.getAttribute("href").split("&selling_plan=")[0];
          if (e.target.value == "subscription") {
            document.querySelector("#ajaxcart-full-price").classList.add("line-through");
            document.querySelector("#ajaxcart-discount-price").classList.remove("hidden");
            this.updateAnchor.setAttribute("href", `${href}&selling_plan=${this.currentValue}`);
          } else {
            document.querySelector("#ajaxcart-full-price").classList.remove("line-through");
            document.querySelector("#ajaxcart-discount-price").classList.add("hidden");
            this.updateAnchor.setAttribute("href", `${href}&selling_plan=`);
          }
        });
      });
    }
  }
};
var RechargeWidget_default = RechargeWidget;

export {
  RechargeWidget_default
};
